var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLoginCadastro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#111827"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(462.4622501904933 290.09619322707556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.3 -355.2C313.9 -333.2 368.9 -263.4 358.2 -191.5C347.6 -119.7 271.2 -45.8 251.8 30.8C232.5 107.5 270 187 258.6 254.2C247.2 321.3 186.9 376.1 120.5 383C54.2 389.9 -18.1 348.9 -105.3 334.4C-192.5 319.9 -294.7 331.9 -344.7 289.9C-394.8 247.9 -392.9 152.1 -364.7 77.5C-336.5 2.9 -281.9 -50.5 -254.3 -118.3C-226.8 -186.2 -226.1 -268.5 -188.2 -305.5C-150.3 -342.5 -75.1 -334.3 5.6 -343C86.3 -351.7 172.6 -377.3 243.3 -355.2",
    fill: "#623bda"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLoginCadastro);
export default __webpack_public_path__ + "static/media/background-login-cadastro.4cb4f24037f40ec882ffb61396744383.svg";
export { ForwardRef as ReactComponent };